import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { useTranslation } from '../../../../translations';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';

const RulesItem = React.forwardRef(function ({ index, text, className }, ref) {
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();
  const textObj = t(text, { returnObjects: true });

  return (
    <div className={`rules__item rules__item_${index} ${className ? className : ''}`} ref={ref}>
      <p className='rules__item-text'>{safeHTML(getLocalizedText(textObj))}</p>
    </div>
  );
});
export default RulesItem;
